import styled from '@emotion/styled';

export const ChartPanel = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 1rem;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
`; 